import { render } from "./App.vue?vue&type=template&id=c2856d06&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c2856d06&lang=scss"

import exportComponent from "/home/christmasatourhouse-com/www/tickets/releases/202610123691/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__